import { Rota } from '../domain/rota.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class RotaSerializer extends DomainSerializer<Rota> {}
